import styled from "styled-components"

export default styled.div`
  margin: 2rem 2.5rem;
  position: relative;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.leftAligned ? "start" : "center")};

  @media (min-width: 48rem) {
    margin: 2rem 0;
    width: 34rem;
  }

  @media (min-width: 64rem) {
    width: 54rem;
  }
`
